import type { FC } from "react";
import ChatDashboard from "./ChatDashboard";
import AdminHomeDashboard from "./AdminHomeDashboard";
import { useCurrentUser } from "../hooks/useCurrentUser";
import { isAdminTierUser } from "../constants/agent";

const HomeRoute: FC = function () {
    const user = useCurrentUser();

    // The admin tier (company admin, Manager, super admin) lands on the
    // dashboard with stats. Everyone else lands directly in the chat workspace.
    if (isAdminTierUser(user)) {
        return <AdminHomeDashboard />;
    }

    return <ChatDashboard />;
};

export default HomeRoute;
